import * as yup from 'yup';

import { fieldPoolIpV4YupValidation } from '@/shared/utils/validationSchema';

export const routerFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
  // direccion: yup.string().required('El campo direccion es requerido'),
  ip: fieldPoolIpV4YupValidation,
  username: yup.string().required('El campo username es requerido'),
  nodo: yup.string().required('El campo nodo es requerido'),
  // password: yup
  //   .string()
  //   .required('El campo password es requerido')
  //   .min(8, 'La contraseña debe tener al menos 8 caracteres')
  //   .max(50, 'La contraseña debe tener como máximo 50 caracteres'),
  estado: yup
    .boolean()
    .typeError('El campo estado es requerido')
    .required('El campo estado es requerido'),
  // clave_api: yup
  //   .string()
  //   .required('El campo clave api es requerido')
  //   .min(8, 'La contraseña debe tener al menos 8 caracteres')
  //   .max(50, 'La contraseña debe tener como máximo 50 caracteres'),
  puerto_api: yup.string().required('El campo puerto api es requerido'),
  // usuario_api: yup.string().required('El campo usuario api es requerido'),
  tipo_router: yup
    .string()
    .typeError('El campo tipo router es requerido')
    .required('El campo tipo router es requerido'),

  // nodo: yup.string().required('El campo nodo es requerido'),
  // olt: yup.string().required('El campo olt es requerido'),

  coordenadas: yup.string().required('El campo coordenadas es requerido'),
});
